module.exports = __webpack_public_path__ + "2.png?bd69843d5d6c9b48b253b5ebe4b47e5e";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/2.png
// module id = 419
// module chunks = 2